/**
 * Define masks used within input
 * We are currently using the minimal version of the inputmasks plugin so
 * for advanced features may have to use bundles version from repo
 *
 * @see lib/inputmask.js
 * @see https://github.com/RobinHerbots/jquery.inputmask/tree/3.x
 */
e.input_masks = {
	init : function(){
		$( '.phone_mask' ).inputmask("(999) 999-9999")
	}

};